import { sliderAnatomy } from '@chakra-ui/anatomy';

export const SLIDER_PARTS = sliderAnatomy.keys;
